import { EventCallback, ClickEvent, EventOptions } from '../types';
import { Data } from '@roc-digital/mxm-base/types';
import { useCustomEvent } from './useCustomEvent';

// The useClickEvent hook allows listening for component click events.
export function useClickEvent<T>(fn: EventCallback<T>, opts?: EventOptions, data?: Data, deps: any[] = []): ClickEvent {
  return useCustomEvent<T>('click', fn, opts, data, deps);
}
